import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router';
import { Location } from 'history';
import { callNativeWeb, footerShowEventWeb } from 'common/appInterface';
import CardApplyStopModal from 'components/CardApplyStopModal';
import { getVersionUrl } from 'common/cacheOverwrite';

const CardReceiveMethodSelect = () => {
  const screenId = "APPL23";

  const location = useLocation() as Location<LocationState>;
  const navigate = useNavigate();

  const {t} = useTranslation();

  const [cardApply] = useState<Partial<CardApplyStep6>>(location.state.apply);
  const [isStop, setStop] = useState(false);

  const closeStop = useCallback(() => setStop(false), []);
  const clickNext = useCallback((receiveMethod: string) => {
    navigate("/apply/step6", { state: { ...location.state, apply: { ...location.state.apply, receiveMethod: receiveMethod}}});
  }, [navigate, location.state]);

  const callbackBackKeyEvent = useCallback(() => {
    // 수령지변경 처리
    if (cardApply.isChangeDelivery) {
      navigate(-1);
    }
    // 카드발급신청 처리
    else {
      setStop(true);
    }
  }, [navigate, cardApply.isChangeDelivery]);

  useEffect(() => {
    // callNative_Web 처리 (WEB > APP)
    callNativeWeb(screenId, t(screenId + ".title", "Select Card Receiving Method"));
    // 하단바 숨기기
    footerShowEventWeb("N");
    // eslint-disable-next-line
  }, []);

  // 뒤로가기 이벤트 리스너 (backKeyEvent_App (APP > WEB))
  useEffect(() => {
    document.addEventListener("backpress", callbackBackKeyEvent);
    return () => document.removeEventListener("backpress", callbackBackKeyEvent);
  }, [callbackBackKeyEvent, navigate]);

  return (
    <div className={"cardReceiveMethod"}>
      <p className={"title"}>{t(screenId + '.explan01', 'Please select the method to receive your card.')}</p>
      <div className={"divider"}/>
      <div>
        <button onClick={() => clickNext('01')}>
          <span>
            <div className={"selectBoxWrap"}>
              <p className={"selectHeader"}>{t(screenId + '.selectHeader01', 'Receive Card by Myself')}</p>
              <p className={"selectDescription blueText"}>{t(screenId + '.selectExplan00', 'Estimated Delivery Time')} : 1 ~ 2 Days</p>
              <p className={"selectDescription grayText"}>{t(screenId + '.selectExplan01', 'We will call you and deliver your card to you directly.')}</p>
            </div>
            <img className={"img16"} src={getVersionUrl('/assets/images/ico/arrow_right_new.png')} alt=""/>
          </span>
        </button>
      </div>
      <div className={"divider"}/>
      <div>
        <button onClick={() => clickNext('02')}>
          <span>
            <div className={'selectBoxWrap'}>
              <p className={"selectHeader"}>{t(screenId + '.selectHeader02', 'Deliver Card to Mailbox')}</p>
              <p className={"selectDescription blueText"}>{t(screenId + '.selectExplan00', 'Estimated Delivery Time')} : 3 ~ 4 Days</p>
              <p className={"selectDescription grayText"}>{t(screenId + '.selectExplan02', 'We will deliver your card to your mailbox or your door.')}</p>
            </div>
            <img className={"img16"} src={getVersionUrl('/assets/images/ico/arrow_right_new.png')} alt=""/>
          </span>
        </button>
      </div>
      <div className={'divider'}/>
      <CardApplyStopModal isStop={isStop} closeStop={closeStop}/>
    </div>
  );
}

export default CardReceiveMethodSelect;